import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateInputFillMode, DateInputRounded, DateInputSize } from '@progress/kendo-angular-dateinputs';
import { forkJoin, of } from 'rxjs';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';

@Component({
  selector: 'app-special-offer-edit-segmentation-modal',
  standalone: false,
  templateUrl: './special-offer-edit-segmentation-modal.component.html',
  styleUrl: './special-offer-edit-segmentation-modal.component.scss',
})
export class SpecialOfferEditSegmentationModalComponent implements OnInit {
  public segmentTypes: app.models.DictionaryDataModel[];
  public segmentItems: app.models.DictionaryDataModel[];
  selectedSegmentItems: app.models.DictionaryDataModel[];

  constructor(
    private readonly dictionaryAPIService: DictionaryAPIService,
    private _activeModal: NgbActiveModal
  ) {}

  public segmentationData;

  public fillModeOutline: DateInputFillMode = 'outline';
  public roundedLarge: DateInputRounded = 'large';
  public sizeLarge: DateInputSize = 'large';

  public segmentationToggle: {
    segment: boolean;
    maximumPaymentDelay: boolean;
    periodUntilTermination: boolean;
  } = {
    segment: false,
    maximumPaymentDelay: false,
    periodUntilTermination: false,
  };

  ngOnInit(): void {
    this.loadData();
    if (this.segmentationData.dictionarySegmentItemTypeExternalEntityId) {
      this.segmentationToggle.segment = true;
    }
    if (this.segmentationData.maximumPaymentDelay) {
      this.segmentationToggle.maximumPaymentDelay = true;
    }
    if (this.segmentationData.periodUntilTermination) {
      this.segmentationToggle.periodUntilTermination = true;
    }
  }

  loadData(): void {
    const segmentTypes$ = this.dictionaryAPIService.getDictionarySegmentTypes();
    const segmentItems$ = this.segmentationData.dictionarySegmentItemTypeExternalEntityId
      ? this.dictionaryAPIService.getDictionarySegmentItems(
          this.segmentationData.dictionarySegmentItemTypeExternalEntityId
        )
      : of(null);

    let source = forkJoin([segmentTypes$, segmentItems$]);
    source.subscribe(([segmentTypes, segmentItems]) => {
      this.segmentTypes = segmentTypes;
      if (segmentItems) {
        this.segmentItems = segmentItems;

        this.selectedSegmentItems = segmentItems.filter(segment =>
          this.segmentationData.segmentItems.some(x => x.dictionarySegmentItemExternalEntityId === segment.id)
        );
      }
    });
  }

  changeSegmentFilterHandler(event: boolean) {
    if (!event) {
      this.segmentationData.dictionarySegmentItemTypeExternalEntityId = null;
      this.segmentationData.segmentItemType = null;
      this.selectedSegmentItems = null;
      this.segmentationData.segmentItems = null;
    }
  }

  changeMaximumPaymentDelayHandler(event: any) {
    if (!event) this.segmentationData.maximumPaymentDelay = null;
  }

  changePeriodUntilTerminationHandler(event: any) {
    if (!event) this.segmentationData.periodUntilTermination = null;
  }

  segmentTypeSelectedHandler(event: string) {
    this.segmentationData.segmentItems = null;
    this.selectedSegmentItems = null;
    if (!event) {
      this.segmentationData.segmentItemType = null;
    } else {
      this.segmentationData.segmentItemType = this.segmentTypes.find(x => x.id === event).value;
      this.dictionaryAPIService.getDictionarySegmentItems(event).subscribe(segmentItems => {
        this.segmentItems = segmentItems;
      });
    }
  }

  campaignTypeSelectedHandler(event: app.models.DictionaryDataModel[]) {
    if (!event) this.segmentationData.campaignType = null;
    else {
      this.segmentationData.segmentItems = event.map(item => {
        const match = this.segmentationData.segmentItems?.find(
          ref => ref.dictionarySegmentItemExternalEntityId === item.id
        );
        return {
          specialOfferXSegmentItemId: match ? match.specialOfferXSegmentItemId : '',
          dictionarySegmentItemExternalEntityId: item.id,
          dictionarySegmentItemName: item.value,
        };
      });
    }
  }

  changeHandler() {
    this._activeModal.close(this.segmentationData);
  }

  closeHandler() {
    this._activeModal.close(false);
  }
}
